// extracted by mini-css-extract-plugin
var _1 = "_productManagementDiscountDetailsForm-module__action-button-disabled";
var _2 = "_productManagementDiscountDetailsForm-module__container";
var _3 = "_productManagementDiscountDetailsForm-module__flex-div";
var _4 = "_productManagementDiscountDetailsForm-module__flex-span-container";
var _5 = "_productManagementDiscountDetailsForm-module__form-container";
var _6 = "_productManagementDiscountDetailsForm-module__form-subcontainer";
var _7 = "_productManagementDiscountDetailsForm-module__label";
var _8 = "_productManagementDiscountDetailsForm-module__label-no-margin";
export { _1 as "action-button-disabled", _2 as "container", _3 as "flex-div", _4 as "flex-span-container", _5 as "form-container", _6 as "form-subcontainer", _7 as "label", _8 as "label-no-margin" }
